/* eslint-disable no-nested-ternary */
/* eslint-disable default-case */
import React, { useCallback, useMemo, lazy, Suspense, useRef, useState, useEffect } from 'react';
import { usePresenceChannel, useChannel, useEvent, PusherProvider } from '@harelpls/use-pusher';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import clsx from 'clsx';
import createPersistedState from 'use-persisted-state';
import {
    Card,
    Collapse,
    Form,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    Input,
    Media,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    NavbarText,
    TabContent,
    TabPane,
    Row,
    Col,
    Button,
    Container,
    FormFeedback,
    InputGroup,
    Spinner
} from 'reactstrap';
import Tour from 'reactour';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup'

import { fetcher } from 'api/client';
import { getExternal, clientContractAction } from 'api/actions/contracts';

import { initialLetters } from 'utils';
import bootbox from 'components/Modals/Bootbox';
import { WordFormatElement } from '../Editor/Canvas/WordFormat';
import { statusesMapper } from 'app-constants';
import Chat from './Chat';
import {
    SignProvider, useSign, useSignDispatch, useSignState,
    CHANGE_TAB, TOGGLE_COMMENTS, CONTROL_OPEN_TOUR, BLOCKCHAIN_MODAL, SHARE_MODAL, LOGIN_MODAL, CONTROL_MODAL, PARTICIPANT_MODAL,
    CONTROL_CHAT, TOGGLE_ACTIVE_NAV, SET_PASSWORD, PHONE_MODAL
} from 'context/signview';
import PDFPreviewOld from './preview/pdf';
import HTMLPreview from './preview/html';
import PagareTab from './sidebar/pagare';
import CompleteTab from './sidebar/complete';
import NegotiationTab from './sidebar/negotiation';
import AttachmentsTab from './sidebar/attachments';
import ConfidentialAttachmentsTab from './sidebar/confidential';
import BlockchainTab from './sidebar/blockchain';
import RelatedContractsTab from './sidebar/related';
import { pusherAuthorizer, pusherConfig } from 'config/pusher';
import Comments from './Comments';

import ParticipantInformation from 'components/Modals/SignView/ParticipantInformation';
import { BreakpointProvider, useBreakpoint } from 'context/breakpoint';
import Footer from './Footer';
import VideoChat,  { ZoomRecord } from 'components/Sign/VideoChat';
import ZoomUploadVideo from 'components/Sign/ZoomUploadVideo';

import { toast } from 'components/Shared/Toast';

const Shield3 = lazy(() => import('components/Modals/SignView/Shield3'));
const Veridoc = lazy(() => import('components/Modals/SignView/Veridoc'));
const OneTimePassword = lazy(() => import('components/Modals/SignView/OneTimePassword'));
const Signature = lazy(() => import('components/Modals/SignView/Signature'));
const Share = lazy(() => import('components/Modals/SignView/Share'));
const Fiel = lazy(() => import('components/Modals/SignView/Fiel'));
const Tutorial = lazy(() => import('components/Modals/SignView/Tutorial'));
const PrivacyAgreement = lazy(() => import('components/Modals/SignView/PrivacyAgreement'));
const Login = lazy(() => import('components/Modals/SignView/Login'));
const SignUp = lazy(() => import('components/Modals/SignView/SignUp'));
const PhoneModal = lazy(() => import('components/Modals/SignView/Phone'));
const NegotiateOrSign = lazy(() => import('components/Modals/SignView/NegotiateOrSign'));
const ConfirmUpload = lazy(() => import('components/Modals/SignView/ConfirmUpload'));
const Blockchain = lazy(() => import('components/Modals/SignView/Blockchain'));
const Ine = lazy(() => import('components/Modals/SignView/Ine'));

const useViewedSteps = createPersistedState('viewed_steps');
const useSignData = createPersistedState('sign_data');

/*

MainContainer / SignView
 _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _
|                  MainNavBar                     |
|_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _|   
|_ _ _ SubHeaderLeftSide _ _ _ |   RightSidebar   |
|     __________________       |                  |
|    |__DocumentHeader__|      |                  |
|    |                  |      |                  |
|    |  EditorPreview   |      |                  |
|    |                  |      |                  |
|    |__________________|      |                  |
|    |      Footer      |      |RightSidebarFooter| 
|_ _ |_ _ _ _ _ _ _ _ _ |_ _ _ | _ _ _ _ _ _ _ _ _| 

*/


export function createMarkup(content) {
    return {
        __html: content
    };
};

export function Circle({ text, className, icon, ...rest }) {
    return <div className={clsx('align-self-center align-middle circle p-2', className)} {...rest}>
        <small>
            <b>
                {text}
            </b>
            {icon && <i className="fas fa-user-plus"></i>}
        </small>
    </div>
}

const WaitingContainer = styled.div`
z-index: 1000000;
position: absolute;
top: 0px;
bottom: 0px;
left: 0px;
right: 0px;
background: rgba(255, 255, 255, 0.7);
`

function Waiter() {
    const { showWaiter } = useSignState();
    const { t } = useTranslation();
    if (!showWaiter) return null;
    return (
        <WaitingContainer >
            <div className="absolute-center">
                <div>
                    <img src="/images/logo-01.svg" alt="loading" width="180px" />
                </div>
                <div className="m-3">
                    <span><b>{t('sign.wait.process')}</b></span>
                </div>
                <div>
                    <span className="font-weight-bold text-muted">{t('sign.wait.wait')}</span>
                </div>
                <img src="/images/loading.svg" alt="loading" width="120px" />
            </div>
        </WaitingContainer>
    )
}

// function ExtraAttachmentsTab() {
//     return (
//         <div id="complete" className="tab-pane active">
//             <div className="complete-container"></div>
//             <div className="complete-attachments-container"></div>
//         </div>
//     );
// }

function Participant({ participant, wasNegotiated }) {
    const { t } = useTranslation();
    const { name = '', status, last_name } = participant;
    const isSignerStatus = ['RECEIVED_SIGNED', 'RECEIVED_TO_SIGN', 'SENT_SIGNED'].includes(status);
    const isNegotiator = participant.isNotSigner && !participant.isNotNegotiator && isSignerStatus;
    const isSpectator = participant.isNotSigner && participant.isNotNegotiator && isSignerStatus;
    const statusText = isNegotiator && wasNegotiated ? 'ACCEPTED_NEGOTIATION_2'
            : isNegotiator ? 'NEGOTIATOR' 
         : isSpectator ? 'SPECTATOR' 
         : status;

    return (
        <Media className="ml-4">
            <Media left className="align-self-center mr-2">
                <Circle text={initialLetters(name, last_name)} className="bg-white border" />
            </Media>
            <Media body className="text-height-1">
                <Media heading className="m-0 ">
                    <small className="font-weight-bold"> {t(`contracts.status_v2.${statusText || ''}`)}</small>
                </Media>
                <small > {t(`contracts.status_message.${statusText || ''}`)}</small>
            </Media>
        </Media>
    )
}

function DocumentHeader() {

    const { contract } = useSignState();
    return (
        <div className="contract-header border-bottom d-flex p-2 bg-white overflow-auto">
            {contract.participants?.map(participant =>
                <Participant
                    key={`p_${participant._id}`}
                    participant={participant} 
                    wasNegotiated={contract.wasNegotiated}   
                    />
            )}
        </div>
    )
}

function ParticipantIcons({ participant }) {
    const { name, _id, last_name } = participant;
    const [{ contractId, profile }, dispatch] = useSign();

    const { members } = usePresenceChannel(`presence-${contractId}`);

    const handleOpenParticipantInfoModal = useCallback(() =>
        dispatch({
            type: CONTROL_MODAL,
            open: PARTICIPANT_MODAL,
            participantId: _id
        }),
        [_id]);

    return (
        <div onClick={handleOpenParticipantInfoModal}>
            {Object.keys(members).includes(_id) || profile?.email === participant?.email ?
                <Circle
                    className="ml-minus-5 glow bg-primary text-white"
                    text={initialLetters(name, last_name)}
                />
                :
                <Circle
                    className="ml-minus-5 bg-white border"
                    text={initialLetters(name, last_name)}
                />
            }
        </div>
    )
}

function HeaderMessage({ currentStatus = '' }) {
    const { t } = useTranslation();

    const headerStatus = statusesMapper[currentStatus];

    if (!headerStatus) return null;

    return (
        <NavbarText className="mr-3 bg-orange-light pl-4 pr-4 text-primary rounded" id="header-status">
            <span>
                <i className={clsx('fas mr-2', headerStatus.icon)}></i>{t(`sign.header_status.${headerStatus.title}`)}
            </span>
        </NavbarText>
    )
}

function MainNavBar() {

    const { contract, profile, jwt } = useSignState();

    const channel = useChannel(contract._id ? `private-${contract._id}` : null);

    const { t } = useTranslation();

    const queryClient = useQueryClient();

    useEvent(channel, 'client-refresh-all', (email) => {

        queryClient.invalidateQueries('client-contract');
    })
    useEvent(channel, 'contract-event', (event) => {

        queryClient.invalidateQueries('client-contract');
    })
    useEvent(channel, 'negotiation-changes', (event) => {

        queryClient.invalidateQueries('client-contract');
    })
    useEvent(channel, 'conversation-message', (event) => {
        queryClient.invalidateQueries('client-conversations');
        queryClient.invalidateQueries('conversation-' + event?.to);
    })

    const dispatch = useSignDispatch();

    const { mutate: mutateDownloadContract } = useMutation(() => fetcher(getExternal(contract._id, 'pdf'), jwt), {
        onSuccess: (data) => {
            if (data.url) window.open(data.url, 'blank')
        }
    })

    const { mutate: mutateRefuseToSign } = useMutation((payload) => fetcher(clientContractAction(contract._id, 'refuseToSign', payload), jwt), {
        onSuccess: () => {
            bootbox.alert(t('El contrato ha sido rechazado con exito'))
        }
    })

    const handleToggleNav = useCallback(() => dispatch({ type: TOGGLE_ACTIVE_NAV }), [dispatch]);

    const handleOpenBlockchain = useCallback(() => dispatch({ type: CONTROL_MODAL, open: BLOCKCHAIN_MODAL }), [dispatch]);

    const handleToggleComments = useCallback(() => dispatch({ type: TOGGLE_COMMENTS }), [dispatch]);

    const handleOpenTutorial = useCallback(() => dispatch({ type: CONTROL_OPEN_TOUR, open: true }), [dispatch]);

    const handleDownloadDocument = useCallback(() => mutateDownloadContract(), [mutateDownloadContract]);

    const handleShareDocument = useCallback(() => dispatch({ type: CONTROL_MODAL, open: SHARE_MODAL }), [dispatch]);
    const handleRefuseToSign = useCallback(async () => {
        const message = `
            <i className="fas fa-exclamation-triangle text-warning fa-2x "></i> Al presionar <strong>"Declinar firma"</strong> el documento será <strong>cancelado</strong>, y notificaremos a la persona que te lo envió sobre tu decisión. <br /> <br />
            Si lo que quieres es realizar un cambio en la información te sugerimos contactar a la persona que te envía el documento puedes hacerlo enviando un comentario, para ello da click en comentarios en la parte superior derecha o bien sobre el párrafo que deseas comentar. <br /> <br />
            <strong>Razón de rechazo:</strong> `
        const reason = await bootbox.prompt({ 
            textT: message,
            labelClassName: 'text-justify',
            validateInput: true,
            buttons: {
                cancel: {
                    label: 'Regresar'
                },
                confirm: {
                    label: 'Declinar firma'
                }
            }
        })
        
        if (reason) mutateRefuseToSign({cancelReason: reason});
        
    }, [mutateRefuseToSign]);

    const signInMobile = () => {
        dispatch({ type: CONTROL_MODAL, open: PHONE_MODAL });
    };

    const handleLogin = useCallback(() => dispatch({ type: CONTROL_MODAL, open: LOGIN_MODAL }), [dispatch]);

    return (
        <Navbar color="white" light fixed="top" expand="lg" className={'border-bottom p-3 text-nowrap'} style={{ zIndex: 3 }}>
            <NavbarBrand className="navbar-brand-simple overflow-hidden" style={{ maxWidth: "calc(100% - 4em)" }}>
                <img
                    src={profile.tenant?.branding?.logo || '/images/logo-01.svg'}
                    width="130px"
                    className="sing-brand-img"
                    height="30px"
                    alt="logo"
                />
                <NavbarText className="font-weight-bold ml-3 p-0">
                    {contract.documentId} - {contract.name}
                </NavbarText>
            </NavbarBrand>
            <NavbarToggler onClick={handleToggleNav} />
            <Collapse navbar>
                <Nav className="mr-auto" navbar>
                </Nav>
                <HeaderMessage currentStatus={contract.signViewOptions?.status} />
                {contract.participants?.map((p, index) => (
                    <ParticipantIcons participant={p} key={`p-icon-${index}`} />
                ))}
                <Circle
                    hidden={profile.tenant?.config?.hideSignInvite}
                    className="ml-minus-5 border bg-white"
                    icon="fas fa-user-plus"
                    onClick={handleShareDocument}
                />
                <Button
                    className="ml-2"
                    hidden={Boolean(!contract.blockchain?.hash)}
                    onClick={handleOpenBlockchain}>
                    {t('blockchain.title')}
                </Button>
                <Button
                    hidden={profile.tenant?.config?.hideSignComments}
                    color="light"
                    className="ml-2"
                    onClick={handleToggleComments}>
                    {t('sign.contract.comments')}
                </Button>
                {/* <Button
                    className="ml-2"
                    color="light"
                    hidden={!contract.signViewOptions?.isTratoUser || localStorage.getItem('jwt')}
                    onClick={handleLogin}>
                    {t('sign.contract.banner_login_action')}
                </Button> */}
                <UncontrolledDropdown inNavbar className="ml-2">
                    <DropdownToggle tag="div" className="d-flex justify-content-center align-items-center">
                        <Circle className="bg-primary text-white" text={initialLetters(profile.fullName)} />
                        <i className="ml-1 fa fa-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem>
                            <Media>
                                <Media left className="align-self-center mr-3">
                                    <Circle className="bg-primary text-white" text={initialLetters(profile.fullName)} />
                                </Media>
                                <Media body className="text-height-1">
                                    <Media heading className="m-0">
                                        <small> {initialLetters(profile.fullName)} </small>
                                    </Media>
                                    <small>{profile.email} </small>
                                </Media>
                            </Media>
                        </DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem onClick={handleRefuseToSign} hidden={!contract.signViewOptions?.showRefuseToSign}>
                            <i className="fas fa-signature mr-2"></i> {t('Declinar firma')}
                        </DropdownItem>
                        <DropdownItem onClick={signInMobile}>
                            <i className="fas fa-mobile mr-2"></i> {t('sign.sign_modal.sign_mobile')}
                        </DropdownItem>
                        <DropdownItem onClick={handleDownloadDocument}>
                            <i className="fas fa-download mr-2"></i> {t('sign.menu.mobile_download')}
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown inNavbar className="ml-2 align-self-center align-middle" hidden={profile.tenant?.config?.hideSignHelp}>
                    <DropdownToggle tag="div">
                        <i className="fas fa-question-circle fa-2x pointer"></i>
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem onClick={handleOpenTutorial}>
                            <i className="fas fa-question-circle"></i>  {t('sign.menu.tutorial')}
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            </Collapse>
        </Navbar>
    )
}

const PasswordSchema = Yup.object().shape({
    password: Yup.string().required('Required')
});

function PasswordPrompt() {

    const { t } = useTranslation();

    const [{ contractId, jwt }, dispatch] = useSign();

    const { register, handleSubmit, errors, setError } = useForm({
        password: '',
        resolver: yupResolver(PasswordSchema)
    })

    const [showPassword, setShowPassword] = useState(false);

    const { mutate: mutateResendPassword,} = useMutation(() => fetcher(clientContractAction(contractId, 'resendPassword'), jwt), {
        onSuccess: () => {
            bootbox.alert(t('sign.sign_mobile_message.success_message'))
        }
    })

    const { mutate: mutateUnlock, isLoading } = useMutation((payload) => fetcher(clientContractAction(contractId, 'unlock', payload), jwt), {
        onSuccess: (data, variables) => {
            toast.success(t('El documento se desbloqueó con éxito'))
            dispatch({ type: SET_PASSWORD, password: variables.password })
        },
        onError: (error) => {
            setError('password', { message: error.message, type: 'required'})
        }
    })

    const handleResendPassword = () => {
        mutateResendPassword();
    }

    const handleSavePassword = (data) => {
        mutateUnlock({
            password:  data.password
        })
    }

    const handleShowPassword = () => setShowPassword(!showPassword);

    return (
        <Form inline noValidate onSubmit={handleSubmit(handleSavePassword)}>
            <InputGroup className="mb-3 w-100">
                <Input
                    type={showPassword ? 'text' : 'password'}
                    block
                    innerRef={register}
                    name="password"
                    disabled={isLoading}
                    placeholder={t('sign.wait.password')}
                    invalid={!!errors?.password?.message}
                />
                <Button color="light" onClick={handleShowPassword} disabled={isLoading}>
                   {isLoading ? <Spinner size="sm" />: <i className="fas fa-eye"></i>}
                </Button>
                <FormFeedback invalid={!!errors?.password?.message}>{t(`errors.${errors?.password?.message}`)}</FormFeedback>
            </InputGroup>
            <Button className="mb-3" color="secondary" block onClick={handleSubmit(handleSavePassword)} disabled={isLoading}>
                {t('sign.wait.unlock')}
            </Button>

            <div>
                <span className="text-dark">{t('sign.wait.not_received')}</span>
                <Button color="default" className="text-primary font-weight-bold" onClick={handleResendPassword}>{t('sign.wait.resend')}</Button>
            </div>
        </Form>
    )
}

function WarningPrompt({ warningMessage, warningMessageProps }) {

    const { contract } = useSignState();

    const { t } = useTranslation();

    const mapError = (error) => {
        switch (error) {
            case 'link_expired': return 'sign.status.link_expired';
            case 'ContractNotFound': return 'sign.status.contract_not_ready_to_sign';
            case 'notInvolved': return 'sign.status.not_invited';
            case 'contractCanceled': return 'sign.status.contract_canceled';
            case 'notReadyToSign': return 'sign.status.contract_not_ready_to_sign';
            default: return `errors.${error}`;
        }
    }

    const participantThatCanceled = warningMessageProps?.participantThatCanceled;
    const hasParticipantCanceled = !!participantThatCanceled?._id;
    return (
        <div>
            <h3>{contract.name}</h3>
            {warningMessage ?
                <div>
                    <p>{t(mapError(warningMessage), { context: warningMessage === 'contractCanceled' && hasParticipantCanceled ? 'by': undefined, name: participantThatCanceled?.obligation === 'legal' ? `${participantThatCanceled?.name}` : `${participantThatCanceled?.name} ${participantThatCanceled?.last_name || ''}`  })}</p>
                    <b><a href="/">{t('sign.status.back_to_trato')}</a></b>
                </div> :
                <div>
                    <p className="mb-4">{t('sign.wait.loading')}</p>
                    <img src="/images/loading.svg" className="loading-animation" alt="" />
                </div>
            }
        </div>
    )
}

function WarningMessage() {

    const { warningMessage, warningMessageProps } = useSignState();

    return (
        <div className="text-center bg-light h-100 d-flex">
            <div className="loading-sign-view">
                <Card className="p-5 mb-5">
                    <img src="/images/logo-01.svg" className="mb-4" alt="" height="40px" />
                    {warningMessage === 'isPasswordProtected' ?
                        <PasswordPrompt />
                        :
                        <WarningPrompt warningMessage={warningMessage} warningMessageProps={warningMessageProps} />
                    }
                </Card>
            </div>
        </div>
    )
}

function EditorPreviewBanner() {

    const { t } = useTranslation();
    const { previewMode } = useSignState();
    if (!previewMode) return null;

    return (
        <div className="text-center bg-warning p-2 font-weight-bold w-100">
            {t('contracts.negotiation.visualization_version')}
        </div>
    )
}

function EditorPreview() {
    const { contract, previewUrl } = useSignState()
    if (contract.importedPdf) return <PDFPreviewOld />
    else if (contract.elements?.length) return <HTMLPreview />
    else if (Object.keys(contract.wordonline || {}).length) return <WordFormatElement wordonline={contract.wordonline} previewUrl={previewUrl} />
    else return null;
}

function MiniTutorialContent({ label }) {

    const { t } = useTranslation();

    const [stateSteps, setStateSteps] = useViewedSteps([]);

    useEffect(() => {
        const set = new Set(stateSteps)
        set.add(label)
        setStateSteps([...set])
    }, [label])

    return (
        <Media>
            <Media className="align-middle align-self-center">
                <img src="/images/owl-logo.svg" height="50px" className="mr-2" alt="logo"></img>
            </Media>
            <Media body className="ml-2">
                {t(`interactive.${label}`)}
            </Media>
        </Media>
    )
}

function InteractiveTutorial() {

    const [signState, dispatch] = useSign();

    const [stateSteps, setStateSteps] = useViewedSteps([]);

    const steps = useMemo(() => [
        {
            selector: '#document-container',
            label: 'documentContainer',
            content: (props) => <MiniTutorialContent label='documentContainer' />,
            shouldShow: () => !!document.getElementById('document-container')
        },
        {
            selector: '#open-chat',
            label: 'openChat',
            content: ({ goTo, inDOM }) => <MiniTutorialContent label='openChat' />,
            shouldShow: () => !!document.getElementById('open-chat')
        },
        {
            selector: '#header-status',
            label: 'headerStatus',
            content: ({ goTo, inDOM }) => <MiniTutorialContent label='headerStatus' />,
            shouldShow: () => !!document.getElementById('header-status')
        },
        {
            selector: '#sidebar-container',
            label: 'sidebarContainer',
            content: ({ goTo, inDOM }) => <MiniTutorialContent label='sidebarContainer' />,
            shouldShow: () => !!document.getElementById('sidebar-container')
        },
        {
            selector: '#footer-bar',
            label: 'footerBar',
            content: ({ goTo, inDOM }) => <MiniTutorialContent label='footerBar' />,
            shouldShow: () => !!document.getElementById('footer-bar')
        },
        {
            selector: '#complete-sidebar',
            label: 'completeSideBar',
            content: ({ goTo, inDOM }) => <MiniTutorialContent label='completeSideBar' />,
            shouldShow: () => !!document.getElementById('complete-sidebar')
        }
    ], []);

    useEffect(() => {
        const hasNewTutorial = steps.findIndex((s) => !stateSteps.includes(s.label) && s.shouldShow())
        if (hasNewTutorial >= 0) {
            // TODO FIX START AT
            dispatch({ type: CONTROL_OPEN_TOUR, open: true, /*tourStartAt: hasNewTutorial*/ })
        }
    }, [stateSteps, steps])

    const handleCloseTour = useCallback(() => {
        dispatch({ type: CONTROL_OPEN_TOUR, open: false })
    }, [dispatch]);

    return (
        <Tour
            startAt={signState.tourStartAt}
            steps={steps.filter((s) => s?.shouldShow())}
            isOpen={signState.isTourOpen && !signState.modal.length}
            onRequestClose={handleCloseTour}
        />
    )
}

const TabsComponents = {
    'negotiation_tab': NegotiationTab,
    'complete_tab': CompleteTab,
    'annexes_tab': AttachmentsTab,
    'sharedocs_tab': ConfidentialAttachmentsTab,
    'blockchain_tab': BlockchainTab,
    'pagare_tab': PagareTab,
    'related_tab': RelatedContractsTab
}

const Tab = ({ tab, ...props }) => {
    if (!tab) return null;
    const Component = TabsComponents[tab];
    return <Component {...props} />
}

function RightSidebar() {

    const { t } = useTranslation();

    const [{ tab, tabs }, dispatch] = useSign();

    const handleTabChange = useCallback((name) => dispatch({ type: CHANGE_TAB, tab: name }), [dispatch]);

    return (
        <div className="overflow-hidden d-flex flex-column h-100">
            <Nav tabs={true} fill className="font-weight-bold">
                {tabs?.map((tb, index) => (
                    <NavItem key={`nab-var-${index}`}>
                        <NavLink
                            className={clsx({ active: tb.name === tab })}
                            onClick={() => handleTabChange(tb.name)}
                        >
                            {t(`sign.menu.${tb.name}`)}
                        </NavLink>
                    </NavItem>
                ))}
            </Nav>
            <div className="overflow-x-auto h-100">
                <TabContent activeTab="1">
                    <TabPane tabId="1" className="p-3">
                        <Tab tab={tab} />
                    </TabPane>
                </TabContent>
            </div>
            <RightSidebarFooter />
        </div>
    )
}

function SubHeaderLeftSide() {

    const { t } = useTranslation();

    const { contract } = useSignState();

    return (
        <div className="text-center text-white bg-secondary p-1">
            <span className="font-weight-bold">{t('sign.header.status')}: </span>
            <span>{t(`contracts.status.${contract.status}`)}</span>
        </div>
    )
}

const MainView = styled(Container)`
margin-top: 66px;
`

const RightSidebarContainer = styled(Col)`
 position: fixed;
 margin-top: 66px;
//  padding: 60px 0 0;
 top: 0px;
 bottom: 0px;
 right: 0px;
 z-index: 2;
`

function SignView() {

    const { isLoading, warningMessage, openComments, activeNav } = useSignState();

    const breakpoints = useBreakpoint();

    if (isLoading || warningMessage) {
        return <WarningMessage />;
    }

    return (
        <div className='h-100 overflow-hidden'>
            {/* <InteractiveTutorial /> */}
            <VideoChat />
            <ZoomRecord />
            <Suspense fallback={<div />}>
                <Tutorial />
                <PrivacyAgreement />
                <Signature />
                <Ine />
                <Fiel />
                <Shield3 />
                <Veridoc />
                <OneTimePassword />
                <Share />
                <Login />
                <SignUp />
                <NegotiateOrSign />
                <PhoneModal />
                <Waiter />
                <ConfirmUpload />
                <Blockchain />
                <ParticipantInformation />
                <ZoomUploadVideo />
            </Suspense>
            <MainNavBar />
            <MainView fluid>
                <Row>
                    <Col md="8" lg="9" className="p-0">
                        <SubHeaderLeftSide />
                        <Container className="p-0">
                            <Row>
                                <Col md={openComments ? '9' : '12'} hidden={openComments && (breakpoints['xs'] || breakpoints['sm'])}>
                                    <DocumentHeader />
                                    <div className="bg-white">
                                        <EditorPreviewBanner />
                                        <EditorPreview />
                                    </div>
                                    <Footer />
                                </Col>
                                <Col md={openComments ? '3' : '0'} className="h-100">
                                    <Comments />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                    <RightSidebarContainer md="4" lg="3" hidden={!activeNav} className={clsx('d-md-block bg-white p-0')}>
                        <RightSidebar />
                    </RightSidebarContainer>
                </Row>
            </MainView>
        </div>
    )
}

function RightSidebarFooter() {

    const [{ activeNav, profile }, dispatch] = useSign();

    const handleOpenChat = useCallback(() => {
        dispatch({ type: CONTROL_CHAT, open: true })
    }, [dispatch])

    const { t } = useTranslation();

    return (
        <div className="mb-5 text-center border-top d-none d-sm-block"/* hidden={activeNav}*/>
            <Button
                hidden={profile.tenant?.config?.hideClientChat}
                onClick={handleOpenChat}
                size="sm"
                className="mb-2 mt-2"
                id="open-chat">
                {t('sign.chat.open_button')}
            </Button>
            <div>
                <small className="d-inline-block">Powered <br />by</small>
                <img src="/images/logo-01.svg" className="logo" width="80" alt="logo" />
            </div>
        </div>
    )
}

function MainContainer() {
    const { jwt, blurMain } = useSignState();
    if (!jwt) return null;
    return (
        <PusherProvider {...pusherConfig} authorizer={(channel, options) => pusherAuthorizer(channel, options, jwt)}>
            <div className={clsx('h-100', blurMain && 'blur')}>
                <BreakpointProvider>
                    <SignView />
                </BreakpointProvider>
                <Chat />
            </div>
        </PusherProvider>
    );
}

export default function MainSignView() {
    return (
        <SignProvider>
            <MainContainer />
        </SignProvider>
    )
}